import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Removes known tracking query parameters from the browser URL on every
 * route change. Analytics (PostHog, GA) capture the original URL on load
 * BEFORE this cleanup runs, so attribution data is preserved.
 *
 * Benefit: cleaner URLs in the user's address bar + helps Google Search
 * Console consolidate duplicates caused by ad/share tracking links
 * (Facebook ads, Google Ads, newsletter campaigns, etc).
 */
const TRACKING_PARAMS = [
  // Google Analytics / Ads
  'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id',
  'gclid', 'gclsrc', 'dclid', 'gbraid', 'wbraid', '_gl', '_ga',
  // Facebook / Meta
  'fbclid', 'fb_action_ids', 'fb_action_types', 'fb_source', 'fb_ref',
  // Microsoft / Bing
  'msclkid',
  // Yandex
  'yclid',
  // Mailchimp
  'mc_eid', 'mc_cid',
  // HubSpot
  '_hsenc', '_hsmi', '__hstc', '__hssc', '__hsfp', 'hsCtaTracking',
  // Instagram / TikTok
  'igshid', 'ttclid',
  // Generic
  'ref', 'referrer', 'src', 'source',
];

const CleanTrackingParams = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (!search) return;

    const params = new URLSearchParams(search);
    let removed = false;

    TRACKING_PARAMS.forEach((p) => {
      if (params.has(p)) {
        params.delete(p);
        removed = true;
      }
    });

    if (removed) {
      const cleanSearch = params.toString();
      const newUrl = pathname + (cleanSearch ? `?${cleanSearch}` : '') + window.location.hash;
      window.history.replaceState({}, '', newUrl);
    }
  }, [pathname, search]);

  return null;
};

export default CleanTrackingParams;
